// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore"; // ✅ correct import

const firebaseConfig = {
  apiKey: "AIzaSyDyJcXvBMUNfkokah_s6GeUHuM2BLjstQM",
  authDomain: "bakerkerryaccountants.firebaseapp.com",
  projectId: "bakerkerryaccountants",
  storageBucket: "bakerkerryaccountants.firebasestorage.app",
  messagingSenderId: "214273958715",
  appId: "1:214273958715:web:bf074c607fb915bed98d1e",
  measurementId: "G-LSQGXT2TPL"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

// Initialize Firestore
export const firebase = getFirestore(app); // ✅ export Firestore instance